const KEYS = {
  completed: 'flea_onboarding_completed',
  pending: 'flea_onboarding_pending',
  intents: 'flea_onboarding_intents',
  checklist: 'flea_onboarding_checklist',
  coachPrefix: 'flea_coach_dismissed_',
};

function safeParse(json, fallback) {
  try {
    return JSON.parse(json);
  } catch {
    return fallback;
  }
}

function asPlainObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function markOnboardingPending() {
  try {
    localStorage.setItem(KEYS.pending, 'true');
  } catch {
    /* ignore */
  }
}

export function isOnboardingPending() {
  try {
    return localStorage.getItem(KEYS.pending) === 'true';
  } catch {
    return false;
  }
}

export function clearOnboardingPending() {
  try {
    localStorage.removeItem(KEYS.pending);
  } catch {
    /* ignore */
  }
}

export function isOnboardingCompleted() {
  try {
    return localStorage.getItem(KEYS.completed) === 'true';
  } catch {
    return false;
  }
}

export function markOnboardingCompleted(selectedIntents = []) {
  try {
    localStorage.setItem(KEYS.completed, 'true');
    localStorage.setItem(KEYS.intents, JSON.stringify(selectedIntents));
    clearOnboardingPending();
  } catch {
    /* ignore */
  }
}

export function getSavedOnboardingIntents() {
  try {
    const parsed = safeParse(localStorage.getItem(KEYS.intents), []);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function getChecklistProgress() {
  try {
    return asPlainObject(safeParse(localStorage.getItem(KEYS.checklist), {}));
  } catch {
    return {};
  }
}

export function markChecklistItemDone(itemId) {
  try {
    const progress = getChecklistProgress();
    progress[itemId] = true;
    localStorage.setItem(KEYS.checklist, JSON.stringify(progress));
  } catch {
    /* ignore */
  }
}

export function isChecklistItemDone(itemId) {
  return Boolean(getChecklistProgress()[itemId]);
}

export function isChecklistFullyComplete(totalItems) {
  const progress = asPlainObject(getChecklistProgress());
  return Object.keys(progress).filter(Boolean).length >= totalItems;
}

export function shouldShowCoachMark(coachId) {
  try {
    return localStorage.getItem(`${KEYS.coachPrefix}${coachId}`) !== 'true';
  } catch {
    return true;
  }
}

export function dismissCoachMark(coachId) {
  try {
    localStorage.setItem(`${KEYS.coachPrefix}${coachId}`, 'true');
  } catch {
    /* ignore */
  }
}
